import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { Modal, WhiteButton } from 'components';
import * as c from 'models/constants';
import { IModalSizes } from 'components/Modal';
import { closeModal } from 'redux/modules/modal';
import { IModalAction } from 'models/modal';
import { browserHistory } from 'react-router';

interface IProps {
	showHeaderCloseButton?: boolean;
	modalTitle: string;
	type: string;
	entityReferenceId?: string;
	modalSize?: IModalSizes['size'];

	/* functions props */
	t?: (key: string) => string;
	closeModal?: (type?: string) => IModalAction;
}

@connect(
	() => ({}),
	(dispatch) => ({
		closeModal: (type?: string) => dispatch(closeModal(type)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AddNewListingModal extends React.Component<IProps> {
	constructor(props) {
		super(props);
		this.handleAddNewarticle = this.handleAddNewarticle.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	private handleAddNewarticle() {
		browserHistory.push('/managearticle');
		this.props.closeModal('AddNewListingModal');
	}

	private closeModal() {
		this.props.closeModal('AddNewListingModal');
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { t } = this.props;

		const generateButton = (text: string, onClick: () => void, disabled?: boolean): JSX.Element => {
			return (
				<div className={`button pointer ${disabled ? ' disabled' : ''}`} onClick={onClick}>
					<p>{text}</p>
				</div>
			);
		};
		const footer = <WhiteButton onClick={this.closeModal}>{t('BSPortal_Common_Cancel')}</WhiteButton>;

		return (
			<Modal
				modalClass="modalAddNewListing"
				title={t('User_Listings_Title_NewPost')}
				showHeaderCloseButton={true}
				closeModal={this.closeModal}
				size={'small'}
				footer={footer}
			>
				<div className="buttonsContainer">
					{generateButton(t('PortalPage_Section_Manage_Common_Picture'), () => {}, true)}
					{generateButton(t('PortalPage_Section_Manage_Common_Story'), () => {}, true)}
					{generateButton(t('PortalPage_Section_Manage_Common_Video'), () => {}, true)}
					{generateButton(t('Magazine_Section_Manage_Common_Label_Article'), () => this.handleAddNewarticle())}
					{generateButton(t('PortalPage_SectionItem_PortalPageSectionItemProduct'), () => {}, true)}
					{generateButton(t('PortalPage_Section_Manage_Common_Event'), () => {}, true)}
				</div>
			</Modal>
		);
	}
}

export { AddNewListingModal };
